import { useGlobalMetrics } from '../queries'

export function MetricsBar() {
  const m = useGlobalMetrics()

  return (
    <header className="bg-zinc-900/70 border-b border-zinc-800 px-4 4k:px-8 py-1.5 4k:py-2 flex items-center justify-between shrink-0">
      <div className="flex items-baseline gap-6 4k:gap-12">
        <Metric label="P0" value={m.totalP0} valueClass="text-red-500" testId="metric-p0-total" />
        <Metric label="PRs>7d" value={m.prsOver7Days} valueClass="text-amber-500" />
        <Metric
          label="CI"
          value={`${m.ciGreenCount}/${m.ciConfiguredCount}`}
          valueClass="text-green-500"
          testId="metric-ci-green"
        />
        <Metric
          label="Bug/Feat sem"
          value={`${m.bugsThisWeek}/${m.featsThisWeek}`}
          valueClass="text-zinc-100"
        />
      </div>
      <div className="text-right flex items-baseline gap-3 4k:gap-5">
        <h1 className="text-base 4k:text-xl font-bold tracking-tight text-zinc-300">WIPHUB</h1>
        <p className="text-[10px] 4k:text-xs text-zinc-600" data-testid="loaded-counter">
          {m.loaded}/{m.total} · 90s
        </p>
      </div>
    </header>
  )
}

function Metric({
  label,
  value,
  valueClass,
  testId,
}: {
  label: string
  value: number | string
  valueClass: string
  testId?: string
}) {
  return (
    <div className="flex items-baseline gap-1.5 4k:gap-2">
      <p className="text-[10px] 4k:text-xs uppercase tracking-widest text-zinc-500">{label}</p>
      <p data-testid={testId} className={`text-xl 4k:text-3xl font-black ${valueClass} leading-none font-mono`}>
        {value}
      </p>
    </div>
  )
}
